import React from 'react';
import {Route} from 'react-router-dom';

import balls from '../../img/balls.png';
import party from '../../img/party.png';
import rabbit from '../../img/rabbit.png';
import saxy from '../../img/saxy.png';
import sugar from '../../img/sugar.png';
import cycle from '../../img/cycle.png';
import './brokBackgroundImg.scss';

const IMAGES = [
	balls,
	party,
	rabbit,
	saxy,
	sugar,
	cycle,
];

let incr = 0;

function randomImage() {
	return IMAGES[(++incr)%IMAGES.length];
}

function generatePosition() {
	const left = !!(Math.random() > 0.5);
	const rest = {
		[left ? 'left' : 'right']: '1vw'
	};

	return {
		width: '20vh',
		...rest
	}
}

let switc = false;

export default () => {
	return (
		<Route path="/" render={({location}) => {
			switc = !switc;
			return <img src={randomImage()} className={`brok-background-img ${switc ? 'brok-background-img-anim-B' : 'brok-background-img-anim-A'}`} style={generatePosition()}/>;
		}} />
	);
};


// WEBPACK FOOTER //
// ./src/modules/BrokBackgroundImg/index.js